import Collapse from '@material-ui/core/Collapse/Collapse'
import Fade from '@material-ui/core/Fade/Fade'
import ListItem from '@material-ui/core/ListItem/ListItem'

import { useStyles } from './styles/RatePlansSelectionModalRow.styles'

interface RatePlansSelectionModalRowProps {
  selectedRateplan: string
  AdotelCode: string
  AdotelName: string
  disabled: boolean
  onClick: () => void
}
const RatePlansSelectionModalRow: React.FC<RatePlansSelectionModalRowProps> = ({
  selectedRateplan,
  AdotelCode,
  AdotelName,
  disabled,
  onClick
}) => {
  const classes = useStyles()

  return (
    <Collapse in={true} key={AdotelCode}>
      <ListItem
        button
        disabled={disabled}
        className={[
          classes.templateItem,
          disabled && classes.disabled,
          selectedRateplan === AdotelCode ? classes.activeTemplateItem : ''
        ].join(' ')}
        onClick={onClick}>
        <Fade in={selectedRateplan === AdotelCode} timeout={250}>
          <span className={classes.activeCircle} />
        </Fade>
        {`${AdotelName} (${AdotelCode})`}
      </ListItem>
    </Collapse>
  )
}
export default RatePlansSelectionModalRow
